<template>
	<div class="home">
	  <SideBar>
		<div class="h-screen relative">
		  <GreenBall
			class="steps__ball w-full"
			start="bottom"
			offset="-2rem"
			cutout="0"
		  />
		  <img
			src="@/assets/img/windmill-sidebar.png"
			alt=""
			class="absolute bottom-28 h-96 2xl:h-2/3"
		  />
		  <div
			class="text-left w-3/4 mx-auto absolute z-10 left-24"
		  >
			<div class="text-3xl">
			  <div
				class="text-grey-3 font-normal"
			  >
				{{ $t('auto_investment.setup.title_sidebar_1') }}
			  </div>
			  <div
				class="text-grey-3 font-medium"
			  >
				{{ $t('auto_investment.self') }}
			  </div>
			</div>
			<div
			  v-if="activeIndex === 0"
			  class="text-grey-3 font-normal text-3xl"
			>
			  {{ $t('auto_investment.setup.title_sidebar_2') }}
			</div>
			<ul v-else class="ml-8 mt-8 text-grey-2">
			  <div v-for="(item, index) in steps" :key="index">
				<li class="mb-4">
				  <transition name="fade" mode="out-in">
					<span
					  v-if="activeIndex <= index + 1"
					  class="steps__bullet"
					  :class="
						index + 1 === activeIndex ? 'steps__bullet--active' : ''
					  "
					>
					  {{ index + 1 }}
					</span>
					<img
					  v-else
					  src="@/assets/img/step_done.png"
					  alt=""
					  class="w-6 absolute"
					/>
				  </transition>
				  <span
					class="ml-9 text-sm"
					:class="activeIndex === index + 1 ? 'font-bold' : ''"
				  >
					{{ item }}
				  </span>
				</li>
			  </div>
			</ul>
		  </div>
		</div>
	  </SideBar>
	  <div
		class="
		  w-full
		  2xl:w-4/5
		  lg:w-2/3
		  ml-auto
		  min-h-screen
		  relative
		  text-left
		  actions
		  lg:pt-20
		  z-0
		"
	  >
		<div
		  class="
			md:w-3/4
			w-4/5
			m-auto
			absolute
			md:relative md:left-0
			left-9
			top-2
			z-50
			mb-8
		  "
		>
		  <transition name="toast-fade">
			<div
			  class="
				back
				text-left text-grey-2
				md:flex
				absolute
				top-5
				items-center
				cursor-pointer
				md:mb-12
			  "
			  @click="previousSlide"
			>
			  <img
				src="@/assets/svg/chev-left.svg"
				alt=""
				class="w-5 md:w-auto"
			  />
  
			  <span class="hidden md:block">{{
				$t('wording.back')
			  }}</span>
			</div>
		  </transition>
		</div>
		<swiper
		  class="w-full"
		  :loop="false"
		  :slides-per-view="1"
		  :space-between="50"
		  :pagination="false"
		  :allowTouchMove="false"
		  :autoHeight="true"
		  :observer="true"
		  :observeParents="true"
		  :speed="400"
		  :autoplay="false"
		  @swiper="setSwiper"
		  @slideChange="slideChange"
		>
		  <swiper-slide>
			<Setup
			  :loading="loading"
			  class="w-4/5 md:w-3/4 mx-auto mt-16 md:mt-0"
			  @next="nextSlide"
			/>
		  </swiper-slide>
		  <swiper-slide>
			<InterestRate
			  :loading="loading"
			  class="w-4/5 md:w-3/4 m-auto mt-6 md:mt-0"
			  @next="nextSlide"
			/>
		  </swiper-slide>
		  <swiper-slide>
			<MaxTerm
			  :loading="loading"
			  class="w-4/5 md:w-3/4 m-auto mt-6 md:mt-0"
			  @next="nextSlide"
			/>
		  </swiper-slide>
		  <swiper-slide>
			<RiskRating
			  :loading="loading"
			  class="w-4/5 md:w-3/4 m-auto mt-6 md:mt-0"
			  @next="nextSlide"
			/>
		  </swiper-slide>
		  <swiper-slide>
			<WalletPercentage
			  :loading="loading"
			  class="w-4/5 md:w-3/4 m-auto mt-6 md:mt-0"
			  @next="nextSlide"
			/>
		  </swiper-slide>
		  <swiper-slide class="hide">
			<ProjectMinMobile
			  :loading="loading"
			  class="w-4/5 md:w-3/4 m-auto mt-6 md:mt-0"
			  @next="nextSlide"
			/>
		  </swiper-slide>
		  <swiper-slide class="hide">
			<ProjectMaxMobile
			  :loading="loading"
			  class="w-4/5 md:w-3/4 m-auto mt-6 md:mt-0"
			  @next="nextSlide"
			/>
		  </swiper-slide>
		  <swiper-slide class="hidden lg:block">
			<InvestmentAmountDesktop
			  :loading="loading"
			  class="w-4/5 md:w-3/4 m-auto mt-6 md:mt-0"
			  @next="nextSlide"
			/>
		  </swiper-slide>
		  <swiper-slide>
			<Confirmation
			  class="w-4/5 md:w-3/4 m-auto mt-6 md:mt-0"
			  :loading="loading"
			  @next="nextSlide"
			/>
		  </swiper-slide>
		</swiper>
	  </div>
	</div>
  </template>
  
  <script>
  import SideBar from '@/components/general/SideBar.vue'
  import InterestRate from '@/components/auto-investment/InterestRate.vue'
  import MaxTerm from '@/components/auto-investment/MaxTerm.vue'
  import WalletPercentage from '@/components/auto-investment/WalletPercentage.vue'
  import RiskRating from '@/components/auto-investment/RiskRating.vue'
  import ProjectMinMobile from '@/components/auto-investment/ProjectMinMobile.vue'
  import ProjectMaxMobile from '@/components/auto-investment/ProjectMaxMobile.vue'
  import InvestmentAmountDesktop from '@/components/auto-investment/InvestmentAmountDesktop.vue'
  import Confirmation from '@/components/auto-investment/Confirmation.vue'
  import GreenBall from '@/components/general/GreenBall.vue'
  import Setup from '@/components/auto-investment/Setup.vue'
  import useAutoInvestment from '@/mixins/useAutoInvestment.js'
  import useGlobalHelpers from '@/mixins/useGlobalHelpers.js'
  import { computed, ref, onMounted, inject } from 'vue'
  import { Swiper, SwiperSlide } from 'swiper/vue'
  import { useStore } from 'vuex'
  import { useRouter } from 'vue-router'
  
  export default {
	name: 'setup-auto-investment',
	components: {
	  SideBar,
	  Setup,
	  Swiper,
	  MaxTerm,
	  RiskRating,
	  ProjectMinMobile,
	  ProjectMaxMobile,
	  InvestmentAmountDesktop,
	  Confirmation,
	  SwiperSlide,
	  InterestRate,
	  WalletPercentage,
	  GreenBall
	},
	setup() {
	  const swiper = ref(null)
	  const loading = ref(false)
	  const { dollarFormatting } = useGlobalHelpers()
	  const { buildAutoInvestmentsSteps } = useAutoInvestment()
	  const store = useStore()
	  const router = useRouter()
	  const steps = ref([])
	  const cookies = inject('vue-cookie')
	  const profile = ref(cookies.getCookie('profile'))
  
	  const activeIndex = computed(() => {
		return swiper.value ? swiper.value.activeIndex : 0
	  })
  
	  // Swipe Next
	  async function nextSlide() {
		swiper.value.slideTo(swiper.value.activeIndex + 1)
	  }
  
	  // Swipe Previous
	  function previousSlide() {
		if (swiper.value.activeIndex > 0) {
		  swiper.value.slideTo(swiper.value.activeIndex - 1)
		} else router.push({ name: 'dashboard' })
	  }
  
	  // Initialize Swiper
	  function setSwiper(value) {
		swiper.value = value
	  }
  
	  // Get Metrics
	  onMounted(async () => {
		await store.dispatch(
		  'setRequestSettings',
		  'autoinvest_min_interest,autoinvest_max_interest'
		)
			 
		let buildSteps = buildAutoInvestmentsSteps()
		steps.value = buildSteps.steps
  
		if (!store.state.metrics.metrics) await store.dispatch('fetchMetrics')
	  })
  
	  function slideChange() {
		var ro = new ResizeObserver(() => {
		  swiper.value.update()
		})
  
		// Observe one or multiple elements
		ro.observe(swiper.value.slides[swiper.value.activeIndex])
	  }
  
	  return {
		dollarFormatting,
		setSwiper,
		slideChange,
		nextSlide,
		loading,
		previousSlide,
		activeIndex,
		buildAutoInvestmentsSteps,
		steps
	  }
	}
  }
  </script>
  
  <style scoped>
  .slider-auto-investment {
	--slider-connect-bg: #b3dabb;
	--slider-bg: #4f59631a;
	--slider-handle-ring-color: #ffffff;
	--slider-handle-bg: #b3dabb;
	--slider-handle-ring-width: 6px;
	--slider-handle-radius: 1000px;
	--slider-tooltip-bg: #b3dabb;
	--slider-tooltip-py: 0.25rem;
	--slider-tooltip-px: 0.25rem;
  }
  
  .slider-horizontal .slider-handle {
	right: -16px;
  }
  
  @media screen and (min-width: 1024px) {
	.hide {
	  display: none !important;
	}
  }
  </style>
  